import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const postInspectionRequest =
  (store_obj, id, navigate) => async (dispatch) => {
    dispatch({ type: "SHOW_LOADING" });
    try {
      const { data } = await auction.post(
        `/auction/create/inspection-request/${id}`,
        store_obj
      );
      dispatch({ type: "HIDE_LOADING" });
      notifySuccess("Inspection Request Created Successfully");
      dispatch({ type: "POST_INSPECT_REQUEST", payload: data });
      navigate(-1);
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "HIDE_LOADING" });
    }
  };

export const getInspectionRequest =
  (currentPage, totalNumberRow) => async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispatch({ type: "GET_INSPECTION_LOGGING" });
    try {
      const { data } = await auction.get(
        `/profile/read/inspections-requested?skip=${skip}&limit=${totalNumberRow}`
      );
      dispatch({ type: "GET_INSPECT_REQUEST", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "GET_INSPECTION_LOGGED" });
    }
  };

export const postResponseInspection =
  (id, sendvalue, resetValue) => async (dispatch) => {
    dispatch({ type: "POST_RESPONSE_LOADDING" });
    try {
      const { data } = await auction.post(
        `/auction/create/inspection-response/${id}`,
        sendvalue
      );

      resetValue({
        inspectionDate: "",
        offers: [],
      });
      notifySuccess(
        "Thank you! Your response has been successfully submitted."
      );
      dispatch({ type: "POST_INSPECT_RESPONSE", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "POST_RESPONSE_LOADDED" });
    }
  };

export const getInspectionRequestForSeller =
  (currentPage, totalNumberRow) => async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispatch({ type: "GET_INSPECTION_LOGGING_SELLER" });
    try {
      const { data } = await auction.get(
        `/auction/read/requested-inspection?skip=${skip}&limit=${totalNumberRow}`
      );

      dispatch({ type: "GET_INSPECT_REQUEST_SELLER", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "GET_INSPECTION_LOGGED_SELLER" });
    }
  };
